module.exports = "/packs/images/svg/accessibility/ramp~7e9496306e7abaa198d022b0c667b6aa.svg";